let pendingGuard = null;

export const setUnsavedGuard = guard => {
  pendingGuard = typeof guard === 'function' ? guard : null;
};

export const clearUnsavedGuard = guard => {
  if (!guard || pendingGuard === guard) {
    pendingGuard = null;
  }
};

export const hasUnsavedGuard = () => pendingGuard !== null;

export const requestNavigation = performNavigation => {
  if (pendingGuard) {
    pendingGuard(performNavigation);
    return false;
  }
  performNavigation();
  return true;
};
